import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  customers: [], 
  loading: false,
  error: null,
  pagination: {},
  selectedCustomer: null
};

/* ================== THUNKS ================== */

export const fetchCustomers = createAsyncThunk(
  'customers/fetch',
  async ({ page = 1, limit = 10, search = '' }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get('/api/admin/customers', {
            params: { page, limit, search }
        });
        return {
            data: response.data?.data?.records || [],
            pagination: response.data?.data?.pagination || {},
        };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const createCustomer = createAsyncThunk(
  'customers/create',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/admin/customers', 
        payload
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const fetchCustomerById = createAsyncThunk(
  'customers/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/admin/customers/${id}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);
export const toggleCustomerStatus = createAsyncThunk(
  'customers/toggle-status',
  async ({id, isActive}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`/api/admin/customers/${id}/toggle-status`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const updateCustomer = createAsyncThunk(
  'customers/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/api/admin/customers/${id}`, formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const deleteCustomer = createAsyncThunk(
  'customers/delete',
  async ({ id }, { rejectWithValue }) => {
    try {
      console.log(id,'id');
      await axiosInstance.delete(`/api/admin/customers/${id}`);
      return { id };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

/* ================== SLICE ================== */

const customerSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        /* FETCH */
        .addCase(fetchCustomers.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchCustomers.fulfilled, (state, action) => {
            const { data, pagination } = action.payload;
            state.loading = false;
            state.pagination = pagination;
            state.customers = data;
        })
        .addCase(fetchCustomers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })        
        .addCase(fetchCustomerById.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedCustomer = action.payload;
        })
        .addCase(toggleCustomerStatus.fulfilled, (state, action) => {
            state.loading = false;
            const updated = action.payload?.data;

            if (updated) {
                state.customers = state.customers.map((c) =>
                    c.id === updated.id ? updated : c
                );
                state.selectedCustomer = updated;
            }
        })
        .addCase(fetchCustomerById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        /* UPDATE */
        .addCase(updateCustomer.fulfilled, (state, action) => {        
            console.log(state,'state');
        })
        .addCase(updateCustomer.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        /* DELETE */
        .addCase(deleteCustomer.fulfilled, (state, action) => {
            state.customers = state.customers.filter(
              (p) => p._id !== action.payload.id
            );
        });
  }
});

export default customerSlice.reducer;